import { WORKING_HOURS_PER_YEAR } from "./time-units";

export const DEFAULT_HOURLY_RATE_USD = 30;

export type WagePeriod = "hour" | "year";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function valueOfTimeUsd(seconds: number, hourlyRateUsd: number): string {
  const safeSeconds = Math.max(0, seconds);
  const safeRate = Math.max(0, Number.isFinite(hourlyRateUsd) ? hourlyRateUsd : 0);
  const dollars = (safeSeconds * safeRate) / 3600;
  return `≈ ${formatter.format(dollars)}`;
}

export function effectiveHourlyRate(amount: number, period: WagePeriod): number {
  if (!Number.isFinite(amount) || amount < 0) return 0;
  return period === "year" ? amount / WORKING_HOURS_PER_YEAR : amount;
}
